import { useDispatch, useSelector } from '.';
import { removePromptItem } from '../redux/action-prompts';
import { ActionPromptType } from '../redux/action-prompts/action-prompt-type';
import { getAddPairForActionPrompts } from '../redux/action-prompts/action-prompt-pairs';

export { ActionPromptType } from '../redux/action-prompts/action-prompt-type';
export { getAddPairForActionPrompts } from '../redux/action-prompts/action-prompt-pairs';

export const usePrompts = () => {
    const activePrompts = useSelector(store => store.actionPrompts.items);
    const dispatch = useDispatch();
    
    const removePrompt = (prompt: ActionPromptType) => {
        dispatch(removePromptItem(prompt));
    }

    const removePrompts = (prompt: ActionPromptType) => {
        const addPrompts = getAddPairForActionPrompts(prompt);
        if (addPrompts.length)
            addPrompts.forEach((item: ActionPromptType) => removePrompt(item));
    }
    
    const hasPrompt = (prompt: ActionPromptType) => {
        return activePrompts.includes(prompt);
    };

    return { activePrompts, removePrompt, removePrompts, hasPrompt };
};
